import { Box, Stack, Tabs, Typography } from "@mui/material"
import { FC, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParamsState } from "src/hooks/useSearchParamsState"
import SaLayout from "./SaLayout"
import { Sl2Tab } from "./Sl2Tab"
import Sstv2MigrationLifecyclePanel from "./sstv2Migration/Sstv2MigrationLifecyclePanel"
import Sstv2SyntheticMigrationTab from "./sstv2Migration/Sstv2SyntheticMigrationTab"

const TabMap: Record<string, number> = {
  lifecycle: 0,
  synthetic: 1,
}
const TabMapReverse: Record<number, string> = {
  0: "lifecycle",
  1: "synthetic",
}

export const SaSstv2MigrationPage: FC = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useSearchParamsState("tab", TabMap.lifecycle + "")
  const handleTabChange = useCallback(
    (_event: React.ChangeEvent<{}>, newValue: number) => setTab(newValue + ""),
    [setTab],
  )

  return (
    <SaLayout selectedMenuItemLabelKey="sstv2Migration">
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 3, md: 5 },
          py: { xs: 4, md: 5 },
          width: "100%",
        }}
      >
        {/* Header */}
        <Stack sx={{ mb: 3 }}>
          <Typography
            sx={{
              fontSize: "0.72rem",
              fontWeight: 600,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "primary.main",
            }}
          >
            {t("adminApp")}
          </Typography>
          <Typography
            variant="h4"
            sx={{ mt: 0.5, fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.15 }}
          >
            {t("sstv2Migration")}
          </Typography>
        </Stack>

        <Box sx={{ borderBottom: "1px solid", borderColor: "rgba(0,0,0,0.08)", mb: 4 }}>
          <Tabs
            value={Number(tab)}
            onChange={handleTabChange}
            sx={{ minHeight: 40, "& .MuiTab-root": { minHeight: 40, py: 1 } }}
          >
            <Sl2Tab label={t("migrationLifecycle")} />
            <Sl2Tab label={t("syntheticMigration")} />
          </Tabs>
        </Box>

        {
          {
            lifecycle: <Sstv2MigrationLifecyclePanel />,
            synthetic: <Sstv2SyntheticMigrationTab />,
          }[TabMapReverse[Number(tab)]]
        }
      </Box>
    </SaLayout>
  )
}

export default SaSstv2MigrationPage
